import drumsIcon from '../assets/art/drums.svg?raw'
import folkSongsIcon from '../assets/art/folk-songs.svg?raw'
import puzzleIcon from '../assets/art/puzzle.svg?raw'
import { COPY } from '../shell/copy'
import { animalsGame } from './animals'
import { colorsGame } from './colors'
import { peekabooGame } from './peekaboo'
import { placeholderGame } from './placeholder'
import { GAME_IDS, type GameId, type GameModule } from './types'
import { assertNever } from '../never'

const GAMES: Record<GameId, GameModule> = {
  peekaboo: peekabooGame,
  animals: animalsGame,
  colors: colorsGame,
  'folk-songs': placeholderGame({
    id: 'folk-songs',
    titleVi: COPY.games['folk-songs'],
    iconSrc: folkSongsIcon,
  }),
  drums: placeholderGame({
    id: 'drums',
    titleVi: COPY.games.drums,
    iconSrc: drumsIcon,
  }),
  puzzle: placeholderGame({
    id: 'puzzle',
    titleVi: COPY.games.puzzle,
    iconSrc: puzzleIcon,
  }),
}

export function getGame(id: GameId): GameModule {
  return GAMES[id]
}

export function listGames(): GameModule[] {
  return GAME_IDS.map((id) => {
    switch (id) {
      case 'peekaboo':
      case 'animals':
      case 'colors':
      case 'folk-songs':
      case 'drums':
      case 'puzzle':
        return GAMES[id]
      default:
        return assertNever(id)
    }
  })
}
